import { include } from '../../doc/app/App';

include({
    name: 'Inbox',
    doc: require('./doc.md'),
    examples: [
        {
            name: 'Example In-App Notifications',
            import: require('./example.src'),
        },
        {
            name: 'Example Notifications different types in separate tabs',
            import: require('./example-archived-type.src'),
        },
        {
            name: 'Menu items in notification slideout',
            import: require('./example-menu-items.src'),
        },
        {
            name: 'Additional Details in notification slideout',
            import: require('./example-additional-details.src'),
        },
        {
            name: 'Example With Initial Filters',
            import: require('./example-with-initial-filters.src'),
        },
    ],
});
